import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { GIF } from '../../components/sdk-page/content-types';
import emoji from '../../images/sdk-emoji.gif';
import gifs from '../../images/sdk-gifs.gif';
import stickers from '../../images/sdk-stickers.gif';
import text from '../../images/sdk-text.gif';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div>
      <h2>{`Content Types`}</h2>
      <p>{`At GIPHY, we believe everything should move and it’s part of our mission to help make everyday conversations more animated. With our growing list of content types, expressing yourself with GIPHY has never been easier.`}</p>
      <p>{`Please note that Emoji and Text, as well as all future releases, are `}<strong parentName="p">{`only available through the SDK.`}</strong></p>
      <h3>{`GIFs`}</h3>
      <p>{`GIFs are short, looping, moving images. Need we say more?`}</p>
      <GIF height="120px" src={gifs} mdxType="GIF" />
      <h3>{`Stickers`}</h3>
      <p>{`Stickers are GIFs with transparent backgrounds. They’re great for layering animated content on top of all kinds of use cases: messaging apps, stories (e.g., IG, Snap, FB etc.), or games. Basically, any time a square frame just won't do.`}</p>
      <GIF height="120px" src={stickers} mdxType="GIF" />
      <h3>{`Emoji`}</h3>
      <p>{`GIPHY Emojis are fully animated emoji stickers. No longer are these familiar, emotive faces frozen in place, as GIPHY emoji brings life and motion to some all time favorites, as well as some new (and uniquely GIPHY) emojis.`}</p>
      <GIF height="120px" src={emoji} mdxType="GIF" />
      <h3>{`Text`}</h3>
      <p>{`GIPHY Text features animated text-based stickers, making it easy to add that perfect amount of sarcasm, enthusiasm, or whatever emotion is needed to the conversation.`}</p>
      <GIF height="120px" src={text} mdxType="GIF" />
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      